import LB1 from '../assets/images/thumbnails/LB1.jpg'
import LB2 from '../assets/images/thumbnails/LB2.jpg'
import LB3 from '../assets/images/thumbnails/LB3.jpg'
import LB4 from '../assets/images/thumbnails/LB4.jpg'
import LB5 from '../assets/images/thumbnails/LB5.jpg'
import LB6 from '../assets/images/thumbnails/LB6.jpg'
import LB7 from '../assets/images/thumbnails/LB7.jpg'
import LB8 from '../assets/images/thumbnails/LB8.jpg'
import LB9 from '../assets/images/thumbnails/LB9.jpg'
import LB10 from '../assets/images/thumbnails/LB10.jpg'
import LB11 from '../assets/images/thumbnails/LB11.jpg'
import LB12 from '../assets/images/thumbnails/LB12.jpg'
import LB13 from '../assets/images/thumbnails/LB13.jpg'
import LB14 from '../assets/images/thumbnails/LB14.jpg'
import LB15 from '../assets/images/thumbnails/LB15.jpg'
import LB161 from '../assets/images/thumbnails/LB16-1.jpg'
import LB162 from '../assets/images/thumbnails/LB16-2.jpg'
import LB17 from '../assets/images/thumbnails/LB17.jpg'
import LB18 from '../assets/images/thumbnails/LB18.jpg'
import LB19 from '../assets/images/thumbnails/LB19.jpg'
import LB201 from '../assets/images/thumbnails/LB20-1.jpg'
import LB202 from '../assets/images/thumbnails/LB20-2.jpg'
import LBP1 from '../assets/images/preview/LBP1.png'
import LBP2 from '../assets/images/preview/LBP2.png'
import LBP3 from '../assets/images/preview/LBP3.png'
import LBP4 from '../assets/images/preview/LBP4.png'
import LBP5 from '../assets/images/preview/LBP5.png'
import LBP6 from '../assets/images/preview/LBP6.png'
import LBP7 from '../assets/images/preview/LBP7.png'
import LBP8 from '../assets/images/preview/LBP8.png'
import LBP9 from '../assets/images/preview/LBP9.png'
import LBP10 from '../assets/images/preview/LBP10.png'
import LBP11 from '../assets/images/preview/LBP11.png'
import LBP12 from '../assets/images/preview/LBP12.png'
import LBP13 from '../assets/images/preview/LBP13.png'
import LBP14 from '../assets/images/preview/LBP14.png'
import LBP15 from '../assets/images/preview/LBP15.png'
import LBP161 from '../assets/images/preview/LBP161.png'
import LBP162 from '../assets/images/preview/LBP162.png'
import LBP17 from '../assets/images/preview/LBP17.png'
import LBP18 from '../assets/images/preview/LBP18.png'
import LBP19 from '../assets/images/preview/LBP19.png'
import LBPH from '../assets/images/preview/LBPH.png'
import LBPA from '../assets/images/preview/LBPA.png'
import LBPN from '../assets/images/preview/LBPN.png'
import LBP201 from '../assets/images/preview/LBP201.png'
import LBP202 from '../assets/images/preview/LBP202.png'
import LBH from '../assets/images/thumbnails/LBH.jpg'
import LBA from '../assets/images/thumbnails/LBA.jpg'
import LBN from '../assets/images/thumbnails/LBN.jpg'
import LB13A from '../assets/images/thumbnails/LB13A.png'
import LBLogo from '../assets/images/logo/LogoLB.png'


const LB = [
  {
    id: 1,
    section: 'LB',
    title: 'Episodio 1 - Canto Mortal',
    thumbnailUrl: LB1,
    webUrl: 'https://www.youtube.com/embed/fl9w1Q7qwJk', // Add the episode URL
    backgroundImage: LBP1,
    seriesLogo: LBLogo,
    description: '',
  },
  {
    id: 2,
    section: 'LB',
    title: 'Episodio 2 - Atropellado',
    thumbnailUrl: LB2,
    webUrl: 'https://www.youtube.com/embed/Wx_NMsWMVg0', // Add the episode URL
    backgroundImage: LBP2,
    seriesLogo: LBLogo,
    description: '',
  },
  {
    id: 3,
    section: 'LB',
    title: 'Episodio 3 - Burro y el Lego Espía',
    thumbnailUrl: LB3,
    webUrl: 'https://www.youtube.com/embed/5UXh4G-HDQQ', // Add the episode URL
    backgroundImage: LBP3,
    seriesLogo: LBLogo,
    description: 'Este es un Remake de el viejo video Legobob EP 3 - El misterio de Igor. Para decirles las verdad : Para mi era muy embarasoso el video Legobob EP 3 - El misterio de Igor, ya que en mi opinion me había quedado mal, y quería quitarlo de youtube,  pero no quería dejarlos sin un EP 3, así que hize esto.',
  },
  {
    id: 4,
    section: 'LB',
    title: 'Episodio 4 - Especial Navideño 2010',
    thumbnailUrl: LB4,
    webUrl: 'https://www.youtube.com/embed/_lJdJNrMBjc', // Add the episode URL
    backgroundImage: LBP4,
    seriesLogo: LBLogo,
    description: 'Llegó la navidad!, legobob esta muy emocionado por abrir sus regalos, pero cuando digo emocionado significa EMOCIONADO!',
  },
  {
    id: 5,
    section: 'LB',
    title: 'Episodio 5 - Alerta Meteoros',
    thumbnailUrl: LB5,
    webUrl: 'https://www.youtube.com/embed/n3UpP4YeocE', // Add the episode URL
    backgroundImage: LBP5,
    seriesLogo: LBLogo,
    description: 'El pronostico anunció una lluvia de meteoros, ahora Legobob tratará de evitar ser meteorizado, acertará o fallará???',
  },
  {
    id: 6,
    section: 'LB',
    title: 'Episodio 6 - SkateBob al Extremo',
    thumbnailUrl: LB6,
    webUrl: 'https://www.youtube.com/embed/2mI0sQbFZ30', // Add the episode URL
    backgroundImage: LBP6,
    seriesLogo: LBLogo,
    description: 'Legobob entra a un concurso de skateboarding, ahora Legobob debe conseguir un skateboard y competir',
  },
  {
    id: 7,
    section: 'LB',
    title: 'Episodio 7 - Dustin el Lego',
    thumbnailUrl: LB7,
    webUrl: 'https://www.youtube.com/embed/C9gJls8PeI8', // Add the episode URL
    backgroundImage: LBP7,
    seriesLogo: LBLogo,
    description: 'Legobob se accidentó gravemente y no podrá hacer el episodio, afortunadamente contrató a alguien más para encargarse de eso!',
  },
  {
    id: 8,
    section: 'LB',
    title: 'Episodio 8 - Mugroso Musculoso',
    thumbnailUrl: LB8,
    webUrl: 'https://www.youtube.com/embed/glyBezhAH5M', // Add the episode URL
    backgroundImage: LBP8,
    seriesLogo: LBLogo,
    description: 'Burro esta interesado en ganar $10,000, para eso debe ganar un concurso de fuerza, pero a veces  ser muy fuerte se te sube a la cabeza.',
  },
  {
    id: 9,
    section: 'LB',
    title: 'Episodio 9 - Burro VS Dustin Versión 2.0',
    thumbnailUrl: LB9,
    webUrl: 'https://www.youtube.com/embed/kmv39zhkGsM', // Add the episode URL
    backgroundImage: LBP9,
    seriesLogo: LBLogo,
    description: 'La historia es la misma, pero la versión 2.0 incluye : - Mejor calidad de video - Mejor calidad de audio - Intro nueva (como la del EP 12) - Subtitulaje (Inglés) - Parte final nueva - Pelea mejorada - Canciónes diferentes (In The End, Breaking the habits)',
  },
  {
    id: 10,
    section: 'LB',
    title: 'Episodio 10 - Pikachú en la Aventura',
    thumbnailUrl: LB10,
    webUrl: 'https://www.youtube.com/embed/Xtx2bc0dPx0', // Add the episode URL
    backgroundImage: LBP10,
    seriesLogo: LBLogo,
    description: 'Legobob encuentra un nuevo amigo, pero no tiene idea de que Pikachu tiene un duro secreto.',
  },
  {
    id: 11,
    section: 'LB',
    title: 'Episodio 11 - La Enfermedad de la PierdePiezSitis',
    thumbnailUrl: LB11,
    webUrl: 'https://www.youtube.com/embed/CnBXbjBFulU', // Add the episode URL
    backgroundImage: LBP11,
    seriesLogo: LBLogo,
    description: 'A Legobob le llega la más espantosa y mortal enfermedad de lego : La pierdepiezsitis',
  },
  {
    id: 12,
    section: 'LB',
    title: 'Episodio 12 - La Amenaza',
    thumbnailUrl: LB12,
    webUrl: 'https://www.youtube.com/embed/wpxTGC-r8vY', // Add the episode URL
    backgroundImage: LBP12,
    seriesLogo: LBLogo,
    description: 'Burro y Pikachu han sido secuestrados, ¿por quien? ¿por qué? descubrelo en este emocionante episodio. Y gracias a TheLuigiDimension por la ayuda!',
  },
  {
    id: 13,
    section: 'LB',
    title: 'Episodio 13 - Super Mario',
    thumbnailUrl: LB13,
    webUrl: 'https://www.youtube.com/embed/9leqvUeyaC0', // Add the episode URL
    backgroundImage: LBP13,
    seriesLogo: LBLogo,
    description: 'Una visita inesperada llega con Legobob persiguiendo a su archienemigo.',
  },
  {
    id: 14,
    section: 'LB',
    title: 'Episodio 14 - Jigsaw y el Juego de la Muerte',
    thumbnailUrl: LB14,
    webUrl: 'https://www.youtube.com/embed/Qn41DzdOXIU', // Add the episode URL
    backgroundImage: LBP14,
    seriesLogo: LBLogo,
    description: 'Pikachu ha sido secuestrado por el amante de juegos asesinos Jigsaw. La verdad no tenía planeado este episodio, una vez vi a mi hermano jugando el videojuego de Saw 2 Flesh and Blood, y tantas trampas me inspiraron a hacer esto.',
  },
  {
    id: 15,
    section: 'LB',
    title: 'Episodio 15 - El VerdeBob',
    thumbnailUrl: LB15,
    webUrl: 'https://www.youtube.com/embed/zVtrTyeaNUM', // Add the episode URL
    backgroundImage: LBP15,
    seriesLogo: LBLogo,
    description: 'Legobob consigue unas piezas verdes que lo empiezan a volver cretinamente malo. ¿Podrán sus amigos hacer algo con este caos?',
  },
  {
    id: 16,
    section: 'LB',
    title: 'Episodio 16 Parte 1 - SkateBob a lo Supremo',
    thumbnailUrl: LB161,
    webUrl: 'https://www.youtube.com/embed/ljKU26_i_7Q', // Add the episode URL
    backgroundImage: LBP161,
    seriesLogo: LBLogo,
    description: 'La segunda parte del torneo de Skateboarding llegó, mientras tanto Mario actúa como nunca antes lo había hecho. Nota : A partir de este episodio, TheLuigiDimension es parte de LegoBob tambien al actuar como el mario que aparece en este episodio.',
  },
  {
    id: 17,
    section: 'LB',
    title: 'Episodio 16 Parte 2 - Parecidos y Viejos Enemigos',
    thumbnailUrl: LB162,
    webUrl: 'https://www.youtube.com/embed/bj3naSjoPz4', // Add the episode URL
    backgroundImage: LBP162,
    seriesLogo: LBLogo,
    description: 'Despues de enterarse de que hay 2 Marios, la aventura se vuelve mas emocionante y peligrosa en una batalla entre parecidos y viejos enemigos.',
  },
  {
    id: 18,
    section: 'LB',
    title: 'Episodio 17 - El Club de Comedia',
    thumbnailUrl: LB17,
    webUrl: 'https://www.youtube.com/embed/t_vKQQNGdOQ', // Add the episode URL
    backgroundImage: LBP17,
    seriesLogo: LBLogo,
    description: 'Legobob se inscribe de comediante en un club de comedia.',
  },
  {
    id: 19,
    section: 'LB',
    title: 'Episodio 18 - Problemas con Yoshi',
    thumbnailUrl: LB18,
    webUrl: 'https://www.youtube.com/embed/IWfA9ofW-fY', // Add the episode URL
    backgroundImage: LBP18,
    seriesLogo: LBLogo,
    description: 'Mario encuentra un huevo de yoshi y esta dispuesto a cuidarlo.',
  },
  {
    id: 20,
    section: 'LB',
    title: 'Episodio 19 - Captura la Bandera',
    thumbnailUrl: LB19,
    webUrl: 'https://www.youtube.com/embed/CDhQZHi7zOI', // Add the episode 
    backgroundImage: LBP19,
    seriesLogo: LBLogo,
    description: 'Pikachu apuesta su casa en un juego de captura la bandera contra el campéon.',
  },
  {
    id: 21,
    section: 'LB',
    title: 'Especial de Halloween',
    thumbnailUrl: LBH,
    webUrl: 'https://www.youtube.com/embed/836ZMUO_tsM', // Add the episode URL
    backgroundImage: LBPH,
    seriesLogo: LBLogo,
    description: 'Fueron 10 dias de retraso pero por fin está aqui, disfrutenlo!',
  },
  {
    id: 22,
    section: 'LB',
    title: 'Fiesta de Aniversario',
    thumbnailUrl: LBA,
    webUrl: 'https://www.youtube.com/embed/y8Q4x4Q0M-w', // Add the episode URL
    backgroundImage: LBPA,
    seriesLogo: LBLogo,
    description: 'Ya pasó 1 año :D',
  },{
    id: 23,
    section: 'LB',
    title: 'Especial Navideño 2011',
    thumbnailUrl: LBN,
    webUrl: 'https://www.youtube.com/embed/3OCyHTb9irY', // Add the episode URL
    backgroundImage: LBPN,
    seriesLogo: LBLogo,
    description: 'Bowser se roba los regalos navideños, hora de recuperarlos! Gracias a "Carlitos15151511" por darme la idea de que alguien se roba los regalos de navidad!',
  },
  {
    id: 24,
    section: 'LB',
    title: 'Episodio 20 - LegoCatastrofes Parte 1',
    thumbnailUrl: LB201,
    webUrl: 'https://www.youtube.com/embed/5KD3E0HBJSs', // Add the episode URL
    backgroundImage: LBP201,
    seriesLogo: LBLogo,
    description: 'Inicia el final.',
  },
  {
    id: 25,
    section: 'LB',
    title: 'Episodio 20 - LegoCatastrofes Parte 2',
    thumbnailUrl: LB202,
    webUrl: 'https://www.youtube.com/embed/vCW6_UJH5P4', // Add the episode URL
    backgroundImage: LBP202,
    seriesLogo: LBLogo,
    description: 'Todo termina.',
  },
  {
    id: 26,
    section: 'LB',
    title: 'LegoBob EP 1 - Canto Mortal (13 Aniversario)',
    thumbnailUrl: LB13A,
    webUrl: 'https://www.youtube.com/embed/wYEmNkctRqo', // Add the episode URL
    backgroundImage: LB13A,
    seriesLogo: LBLogo,
    description: 'Despues de tanto tiempo, LegoBob encuentra sus piernas y su boca original. Ahora decide recrear el primer episodio de su serie para ver si todavía tiene el toque que lo hizo famoso... No esperen info. del canal en este video, comoquiera recuerden quedarse hasta el final ;)',
  },
  ];

  export default LB;
